import React from 'react';
import useMachineComs from './useMachineComs';
import useQrScanner from './useQrScanner';
import useVendAdjustments from './useVendAdjustments';
import usePageChangeListner from './usePageChangeListner';
import useOnScreenKeyboard from './useOnScreenKeyboard';
import useDynamicStyle from './useDynamicStyles';
import VendExp from '../models/VendExp';
import styled from 'styled-components';
import ScreenKeyboard from './ScreenKeyboard';
import PageHandler from './PageHandler';
import 'react-simple-keyboard/build/css/index.css';
import useSessionHandler from './useSessionHandler';
import ApplicationStore from './ApplicationStore';

type Props = {
  experience: VendExp;
  previewPageId?: string;
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  .react-simple-keyboard {
    width: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    padding: 32px 24px !important ;
  }
  .vendx-logo {
    position: absolute;
    top: 20%;
    left: -50%;
    width: 20%;
    transform: translateX(-50%);
  }
`;

export const PageContext = React.createContext<{
  activePageId: string | null;
  experience: VendExp;
  previewMode: boolean;
  store: ApplicationStore;
}>({ activePageId: null, experience: {} as VendExp, previewMode: false, store: {} as ApplicationStore});

const Viewer: React.FC<Props> = ({ experience, previewPageId }) => {
  useVendAdjustments();
  useMachineComs();
  const activePage = usePageChangeListner();
  useQrScanner();
  useDynamicStyle(experience.styles);
  const { showKeyboard, focusPosition } = useOnScreenKeyboard();
  const store = useSessionHandler(activePage, experience.pages, experience.scripts);


  return (
    <Wrapper id="VENDEX_VIEWER">
      <PageContext.Provider
        value={{
          activePageId: previewPageId ? previewPageId : activePage,
          experience,
          previewMode: previewPageId ? true : false,
          store
        }}>
        <PageHandler />
      </PageContext.Provider>
      {showKeyboard && <ScreenKeyboard elementPosition={focusPosition} />}
    </Wrapper>
  );
};

export default Viewer;
